module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAMFBMVEUAAAD/VVX/QED5MTH5MDD5MjL5MjL4MjL4MTH4MTH4MDD4MTH4MTH4MTH4MTH4MTGMICZpAAAAD3RSTlMAAwRUVVZXbG1ub9TW/P0QXBdnAAAASUlEQVQI12Ng3fv////bAQwM9v9B4CsDw/5FDAwMGr8ZGO4rABlMfxkY/jOAwH8SGXDt+ycBGeJAA/3BVnxjYGA7C6TfJDBgAgC6TStNY2H2NAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/time_e@2x.png
// module id = yuaA
// module chunks = 0